import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { gsap } from "gsap";
import Cookies from "js-cookie";
import SupportForm from "../../components/SupportForm";
import TicketList from "../../components/SupportForm/TicketList";
import TicketDetail from "../../components/SupportForm/TicketDetail";
import StaffDashboard from "../../components/SupportForm/StaffDashboard";
import configData from "../../config.json";
import "./Support.css";

function Support(props) {
  const [loaded, setLoaded] = useState(false);
  const [ticketRefresh, setTicketRefresh] = useState(0);
  const [viewAsClient, setViewAsClient] = useState(false);
  const navigate = useNavigate();
  const { ticketId: ticketIdParam } = useParams();
  const selectedTicketId = ticketIdParam ? Number(ticketIdParam) : null;

  // Check if user is staff
  const isStaff = props.isStaff || false;

  useEffect(() => {
    let rowTl0;
    if (loaded) {
      rowTl0 = gsap.timeline({
        defaults: {
          ease: "power1"
        }
      });
      rowTl0.fromTo("#supportPage h1.anim0", { translateY: "40px" }, { translateY: "0" });
      rowTl0.fromTo("#supportPage h1.anim0", { opacity: 0 }, { opacity: 1 }, "<");
      rowTl0.fromTo("#supportPage .supportContent", { translateY: "40px" }, { translateY: "0" });
      rowTl0.fromTo("#supportPage .supportContent", { opacity: 0 }, { opacity: 1 }, "<");
    }
    return () => {
      rowTl0 && rowTl0.kill();
    };
  }, [loaded]);

  useEffect(() => {
    const cookie = Cookies.get("_udxdworkid");
    if (!cookie) {
      navigate("/signin");
      return;
    }

    gsap.to("#core", { backgroundColor: "#ffffff", duration: 0.3 });
    props.menuColor("none");
    props.accentColor("#FFFFFF");
    props.logoColor("fillBlack");

    document.title = "Support | " + configData.BASE_TITLE;
    document.querySelector('meta[name="description"]').setAttribute("content", "Submit a support ticket");
    document.documentElement.scrollTop = 0;

    setLoaded(true);
  }, [navigate, props]);

  const handleTicketSelect = (ticketId) => {
    navigate(`/support/${ticketId}`);
    document.documentElement.scrollTop = 0;
  };

  const handleTicketClose = () => {
    navigate('/support');
    setTicketRefresh(prev => prev + 1);
  };

  const handleTicketCreated = () => {
    // Trigger refresh of ticket list when a new ticket is created
    setTicketRefresh(prev => prev + 1);
  };

  const handleViewAsClient = () => {
    setViewAsClient(true);
    navigate('/support');
  };

  const handleBackToStaffView = () => {
    setViewAsClient(false);
    navigate('/support');
  };

  // Determine if we should show staff view
  const showStaffView = isStaff && !viewAsClient;

  return (
    <CSSTransition in={loaded} timeout={200} unmountOnExit classNames="pageItem">
      <div id="supportPage">
        <div className="column">
          <h1 className="anim0">Support{showStaffView ? ' Dashboard' : ''}</h1>
          <div className="supportContent">
            {selectedTicketId ? (
              <TicketDetail
                ticketId={selectedTicketId}
                onClose={handleTicketClose}
                isStaff={isStaff}
              />
            ) : showStaffView ? (
              <StaffDashboard
                onSelectTicket={handleTicketSelect}
                onViewAsClient={handleViewAsClient}
                refreshTrigger={ticketRefresh}
              />
            ) : (
              <>
                {isStaff && viewAsClient && (
                  <button className="backToStaffView" onClick={handleBackToStaffView}>
                    Back to Staff Dashboard
                  </button>
                )}
                <p className="intro">
                  Need help? Submit a support ticket below and our team will get back to you.
                </p>
                <SupportForm fonts={props.fonts} onTicketCreated={handleTicketCreated} />
                <TicketList
                  onSelectTicket={handleTicketSelect}
                  refreshTrigger={ticketRefresh}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </CSSTransition>
  );
}

export default Support;
